export enum SocketMethod {
    GetSourcesList = "getSourcesList",
    GetSource = "getSource",
    SubscribeTelemetry = "subscribeTelemetry",
    GetQueryList = 'getQueryList',
    GetQueryById = 'getQueryById',
    CreateQuery = 'createQuery',
    DeleteQuery = 'deleteQuery',
    SaveQuery = 'saveQuery',
    GetDashboardsList = "getDashboardsList",
    GetDashboardById = "getDashboardById",
    SaveDashboard = "saveDashboard",
    CreateDashboard = "createDashboard",
    DeleteDashboard = "deleteDashboard",
    GetData = "getData",
    GetSourceDTC = "getSourceDTC",
    TestRoute = "testRoute",
    KeepAlive = "ping",
    UnsubscribeTelemetry = "unsubscribeTelemetry"
}